import * as constants from "./constants";

export const setProjectDetailsIsEdit = (data) => {
  return {
    type: constants.PROJECT_DETAILS_IS_EDIT,
    data: data,
  };
};

export const createProject = (data) => {
  return {
    type: constants.CREATE_PROJECT,
    data: data,
  };
};

export const createProjectSuccess = (data) => {
  return {
    type: constants.CREATE_PROJECT_SUCCESS,
    data: data,
  };
};

export const createProjectError = () => {
  return {
    type: constants.CREATE_PROJECT_ERROR,
  };
};

export const fetchProject = (data) => {
  return {
    type: constants.FETCH_PROJECT,
    data: data,
  };
};

export const fetchProjectSuccess = (data) => {
  return {
    type: constants.FETCH_PROJECT_SUCCESS,
    data,
  };
};

export const fetchProjectError = () => {
  return {
    type: constants.FETCH_PROJECT_ERROR,
  };
};

export const updateProject = (data) => {
  return {
    type: constants.UPDATE_PROJECT,
    data: data,
  };
};

export const updateProjectSuccess = (data) => {
  return {
    type: constants.UPDATE_PROJECT_SUCCESS,
    data: data,
  };
};

export const updateProjectError = () => {
  return {
    type: constants.UPDATE_PROJECT_ERROR,
  };
};

export const fetchProjectDetailsUtils = () => {
  return {
    type: constants.FETCH_PROJECTS_UTIL_DATA,
  };
};

export const fetchProjectDetailsUtilsSuccess = (data) => {
  return {
    type: constants.FETCH_PROJECTS_UTIL_DATA_SUCCESS,
    data,
  };
};

export const fetchAllProjects = (data) => {
  return {
    type: constants.FETCH_ALL_PROJECTS,
    data,
  };
};

export const fetchAllProjectsSuccess = (data) => {
  return {
    type: constants.FETCH_ALL_PROJECTS_SUCCESS,
    data,
  };
};
export const fetchAllProjectsError = (data) => {
  return {
    type: constants.FETCH_ALL_PROJECTS_ERROR,
    data,
  };
};
export const deleteProject = (data) => {
  return {
    type: constants.DELETE_PROJECT,
    data,
  };
};

export const deleteProjectSuccess = (data) => {
  return {
    type: constants.DELETE_PROJECT_SUCCESS,
    data,
  };
};

export const deleteProjectError = (data) => {
  return {
    type: constants.DELETE_PROJECT_ERROR,
    data,
  };
};

export const deleteProjectAttach = (data) => {
  return {
    type: constants.DELETE_PROJECT_ATTACH,
    data,
  };
};

export const deleteProjectAttachSuccess = (data) => {
  return {
    type: constants.DELETE_PROJECT_ATTACH_SUCCESS,
    data,
  };
};

export const deleteProjectAttachError = (data) => {
  return {
    type: constants.DELETE_PROJECT_ATTACH_ERROR,
    data,
  };
};

export const projectDetailCleanupFunc = () => {
  return {
    type: constants.PROJECT_DETAIL_CLEANUP_FUNC,
  };
};

export const setProjectNotificationIsEdit = (data) => {
  return {
    type: constants.PROJECT_NOTIF_IS_EDIT,
    data: data,
  };
};

export const updateProjectNotifications = (data) => {
  return {
    type: constants.UPDATE_PROJECT_NOTIFICATION,
    data: data,
  };
};

export const updateProjectNotificationsSuccess = (data) => {
  return {
    type: constants.UPDATE_PROJECT_NOTIFICATION_SUCCESS,
    data: data,
  };
};

export const updateProjectNotificationsError = () => {
  return {
    type: constants.UPDATE_PROJECT_NOTIFICATION_ERROR,
  };
};

// Project Weights Actions
export const setProjectWeightsIsEdit = (data) => {
  return {
    type: constants.PROJECT_WEIGHTS_IS_EDIT,
    data: data,
  };
};

export const updateProjectWeights = (data) => {
  return {
    type: constants.UPDATE_PROJECT_WEIGHTS,
    data: data,
  };
};

export const updateProjectWeightsSuccess = (data) => {
  return {
    type: constants.UPDATE_PROJECT_WEIGHTS_SUCCESS,
    data: data,
  };
};

export const updateProjectWeightsError = () => {
  return {
    type: constants.UPDATE_PROJECT_WEIGHTS_ERROR,
  };
};

// Project Priorities Actions
export const setProjectPrioritiesIsEdit = (data) => {
  return {
    type: constants.PROJECT_PRIORITIES_IS_EDIT,
    data: data,
  };
};

export const updateProjectPriorities = (data) => {
  return {
    type: constants.UPDATE_PROJECT_PRIORITIES,
    data: data,
  };
};

export const updateProjectPrioritiesSuccess = (data) => {
  return {
    type: constants.UPDATE_PROJECT_PRIORITIES_SUCCESS,
    data: data,
  };
};

export const updateProjectPrioritiesError = () => {
  return {
    type: constants.UPDATE_PROJECT_PRIORITIES_ERROR,
  };
};

// Project Priority API Actions
export const fetchProjectPriorities = (projectId) => {
  return {
    type: constants.FETCH_PROJECT_PRIORITIES,
    data: projectId,
  };
};

export const fetchProjectPrioritiesSuccess = (data) => {
  return {
    type: constants.FETCH_PROJECT_PRIORITIES_SUCCESS,
    data: data,
  };
};

export const fetchProjectPrioritiesError = (error) => {
  return {
    type: constants.FETCH_PROJECT_PRIORITIES_ERROR,
    error: error,
  };
};

export const createProjectPriority = (data) => {
  return {
    type: constants.CREATE_PROJECT_PRIORITY,
    data: data,
  };
};

export const createProjectPrioritySuccess = (data) => {
  return {
    type: constants.CREATE_PROJECT_PRIORITY_SUCCESS,
    data: data,
  };
};

export const createProjectPriorityError = (error) => {
  return {
    type: constants.CREATE_PROJECT_PRIORITY_ERROR,
    error: error,
  };
};

export const updateProjectPriority = (data) => {
  return {
    type: constants.UPDATE_PROJECT_PRIORITY,
    data: data,
  };
};

export const updateProjectPrioritySuccess = (data) => {
  return {
    type: constants.UPDATE_PROJECT_PRIORITY_SUCCESS,
    data: data,
  };
};

export const updateProjectPriorityError = (error) => {
  return {
    type: constants.UPDATE_PROJECT_PRIORITY_ERROR,
    error: error,
  };
};

export const deleteProjectPriority = (id) => {
  return {
    type: constants.DELETE_PROJECT_PRIORITY,
    data: id,
  };
};

export const deleteProjectPrioritySuccess = (data) => {
  return {
    type: constants.DELETE_PROJECT_PRIORITY_SUCCESS,
    data: data,
  };
};

export const deleteProjectPriorityError = (error) => {
  return {
    type: constants.DELETE_PROJECT_PRIORITY_ERROR,
    error: error,
  };
};

export const sortProjectPriorities = (data) => {
  return {
    type: constants.SORT_PROJECT_PRIORITIES,
    data: data,
  };
};

export const sortProjectPrioritiesSuccess = (data) => {
  return {
    type: constants.SORT_PROJECT_PRIORITIES_SUCCESS,
    data: data,
  };
};

export const sortProjectPrioritiesError = (error) => {
  return {
    type: constants.SORT_PROJECT_PRIORITIES_ERROR,
    error: error,
  };
};
